export enum LeagueTemplateEventStatus {
    ACTIVE = 1, //details coming soon
    FINISHED = 2,
    EXTERNAL = 3,
    CANCELLED = 4
}